import React from 'react';

import {  imageBaseUrls } from '../../constant/ApiUrls';

import { Row, Col } from 'react-bootstrap';

import {
    Header,
    Divider,
    LoaderContainer,
    FormGroup,
    Label,
    Input,
    Textarea,
    SubmitButton,
    SectionTitle,
    StorySection,
    StoryImage,
    StoryText
} from './about_us_styles';


const Loader = () => (
    <div className="spinner" />
);


const AboutUsSection = ({
    loading,
    aboutUs,
    editAboutUS,
    formData,
    formErrors,
    buttonLoading,
    handleChange,
    handleSubmit,
}) => {
    if (loading) {
        return (
            <LoaderContainer>
                <span>Loading...</span>
            </LoaderContainer>
        );
    }

    if (aboutUs?.status === 2 || editAboutUS) {
        return (
            <form onSubmit={handleSubmit}>
                <Header>Create About Us</Header>
                <Divider />

                <FormGroup>
                    <Label>Image</Label>
                    <div
                        onClick={() => document.getElementById('imageInput').click()}
                        style={{
                            width: '100%',
                            maxWidth: '300px',
                            height: '200px',
                            border: '2px dashed #ccc',
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            overflow: 'hidden',
                            margin: '0 auto',
                            backgroundColor: '#f9f9f9',
                        }}
                    >
                        {formData.image ? (
                            <img
                                src={URL.createObjectURL(formData.image)}
                                alt="Selected"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '10px',
                                }}
                            />
                        ) : formData.image_uploaded ? (
                            <img
                                src={imageBaseUrls(formData.image_uploaded)}
                                alt="Uploaded"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '10px',
                                }}
                            />
                        ) : (
                            <span style={{ color: '#888' }}>Upload Image</span>
                        )}
                    </div>
                    <input
                        id="imageInput"
                        type="file"
                        name="image"
                        accept="image/*"
                        onChange={handleChange}
                        style={{ display: 'none' }}
                    />
                    {formErrors.image && (
                        <span style={{ color: 'red', display: 'block', textAlign: 'center', marginTop: '8px' }}>
                            {formErrors.image}
                        </span>
                    )}
                </FormGroup>

                <FormGroup>
                    <Label>Title</Label>
                    <Input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        required
                    />
                    {formErrors.title && <span style={{ color: 'red' }}>{formErrors.title}</span>}
                </FormGroup>

                <FormGroup>
                    <Label>Description</Label>
                    <Textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        rows="5"
                        required
                    />
                    {formErrors.description && <span style={{ color: 'red' }}>{formErrors.description}</span>}
                </FormGroup>

                <SubmitButton type="submit" disabled={buttonLoading}>
                    {buttonLoading ? <Loader /> : 'Submit'}
                </SubmitButton>
            </form>
        );
    }

    // Display view mode
    return (
        <>
            <SectionTitle>{aboutUs.data.title}</SectionTitle>
            <StorySection>
                <Row>
                    <Col md={12} className="mx-auto">
                        <div className="row mt-5">
                            <div className="col-6">
                                <StoryImage
                                    src={
                                        aboutUs.data.image
                                            ? imageBaseUrls(aboutUs.data.image)
                                            : "https://mclaren.scene7.com/is/image/mclaren/07_GT_Front_34_Dynamic-1:crop-16x9?wid=1920&hei=1080"
                                    }
                                    alt="Our Story"
                                />
                            </div>
                            <div className="col-6">
                                <StoryText>{aboutUs.data.description}</StoryText>
                            </div>
                        </div>
                    </Col>
                </Row>
            </StorySection>
        </>
    );
};


export default AboutUsSection;
